import {
  FilterTypes,
  GroupingRule,
  GroupType,
  ReferenceDirection,
} from '@ardoq/api-types';
import { ComponentLabelSource, ReferenceLabelSource } from '@ardoq/data-model';

export const MODERNIZED_BLOCK_DIAGRAM_LEAF_IMAGE_CLIP_PATH =
  'leaf-image-clip-path';

export const GROUP_BY_PARENT_ALL: GroupingRule = Object.freeze({
  type: GroupType.PARENT_ALL,
  direction: ReferenceDirection.UNSET,
  workspaceId: '',
  targetId: '',
});

export const NO_LINK_TARGET_DECORATION = 'noLinkTargetDecoration';

export const DEFAULT_COMPONENT_LABEL_FILTER = {
  affectComponent: true,
  affectReference: false,
  isNegative: false,
  name: '',
  type: FilterTypes.COMPONENT_LABEL,
  value: ComponentLabelSource.NAME,
} as const;

export const DEFAULT_MULTI_LABEL_REFERENCE_FORMATTING_FILTER_ATTRIBUTES = [
  {
    affectComponent: false,
    affectReference: true,
    isNegative: false,
    name: '',
    type: FilterTypes.REFERENCE_LABEL,
    value: ReferenceLabelSource.REFERENCE_TYPE,
  },
];

export { DEFAULT_REFERENCE_LABEL_FILTER as DEFAULT_LEGACY_REFERENCE_LABEL_FORMATTING_FILTER_ATTRIBUTES } from '@ardoq/filter-interface';
